// extracted by mini-css-extract-plugin
export default {"title":"Title_title__MxNSH","title-small":"Title_title-small__q8pEi","title-medium":"Title_title-medium__KS-NL"};